import { Grid, TextField } from "@deere/fuel-react";
import { SECTION_NAME_LABEL, SECTION_DESCRIPTION_LABEL, SECTION_NAME, SECTION_DESCRIPTION, LONG_DESCRIPTION, DESCRIPTION } from  "../../../../utils/surveyLiterals";
const DetailsTab = ({ section, changeHandler }) => {
  return (
    <Grid container mt={4} spacing={4}>
      <Grid item xs={6}>
        <TextField
          label={SECTION_NAME_LABEL}
          required
          placeholder={SECTION_NAME}
          name={DESCRIPTION}
          onChange={(e) => {
            changeHandler(e, section.code);
          }}
          value={section.description}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label={SECTION_DESCRIPTION_LABEL}
          placeholder={SECTION_DESCRIPTION}
          name={LONG_DESCRIPTION}
          onChange={(e) => {
            changeHandler(e, section.code);
          }}
          value={section.longDescription}
        />
      </Grid>
    </Grid>
  );
};

export default DetailsTab;
